/* Coyote howl: a short celebration on Add to cart buttons. Styles are in coyote-howl.css */
(function(){
  var SEL='#b-add,#msb-checkout,#msb-repAdd,.product-form__submit[name="add"]',DUR=2200,until=0,passing=false;
  var STAR='<path d="M17 2l3 11 11 4-11 4-3 11-3-11L3 17l11-4z" stroke="#272420" stroke-width="1.5" stroke-linejoin="round"';
  var COY='<span class="chw-coy"><i class="j"></i><i class="c"></i><i class="h"></i><svg viewBox="0 0 240 248" aria-hidden="true"><g transform="rotate(8 103 122)"><ellipse class="lf" cx="103" cy="122" rx="25" ry="33" fill="#fff"/></g><path class="ll" d="M82 126c10 12 30 13 42 0" fill="none" stroke="#161616" stroke-width="7" stroke-linecap="round"/><g transform="rotate(-14 162 108)"><ellipse class="lf" cx="162" cy="108" rx="17" ry="26" fill="#fff"/></g><path class="ll" d="M149 113c6 8 19 7 27-4" fill="none" stroke="#161616" stroke-width="6" stroke-linecap="round"/></svg></span>';
  function howl(btn){
    if(!btn||btn.querySelector('.chw'))return;
    var w=btn.offsetWidth/2,bits=[];
    btn.classList.add('chw-host');
    var o=document.createElement('span');o.className='chw';o.setAttribute('aria-hidden','true');o.innerHTML=COY+'<span>Woo-hoo!</span>';bits.push(o);
    var wv=document.createElement('span');wv.innerHTML='<svg class="chw-wv" viewBox="0 0 40 40" aria-hidden="true"><path d="M6 30a14 14 0 0 1 4-16M14 34a22 22 0 0 1 6-26M22 37a30 30 0 0 1 8-34" fill="none" stroke="#272420" stroke-width="3" stroke-linecap="round"/></svg>';bits.push(wv.firstChild);
    [[-1,-44,'#fff'],[1,-48,'#d0e8f5'],[-.75,42,'#f2d4d9'],[.8,40,'#f3eccd']].forEach(function(p){
      var s=document.createElement('span');s.innerHTML='<svg class="chw-sp" viewBox="0 0 34 34" aria-hidden="true" style="--x:'+Math.round(p[0]*w)+'px;--y:'+p[1]+'px">'+STAR+' fill="'+p[2]+'"/></svg>';bits.push(s.firstChild);
    });
    bits.forEach(function(b){btn.appendChild(b);});
    until=Date.now()+DUR;
    setTimeout(function(){bits.forEach(function(b){if(b.parentNode)b.parentNode.removeChild(b);});btn.classList.remove('chw-host');},DUR);
  }
  window.coyoteHowl=howl;
  document.addEventListener('click',function(e){
    var b=e.target&&e.target.closest?e.target.closest(SEL):null;
    if(b&&!b.disabled)howl(b);
  },true);
  /* If the page heads to the cart mid-howl, let him finish first */
  if(window.navigation&&navigation.addEventListener){
    navigation.addEventListener('navigate',function(e){
      var left=until-Date.now();
      if(passing||left<=0||!e.cancelable||e.hashChange||e.downloadRequest)return;
      var url=e.destination&&e.destination.url;if(!url)return;
      e.preventDefault();passing=true;setTimeout(function(){window.location.href=url;},left);
    });
  }
})();
